import React, { useMemo } from "react";

import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { getDateUpdate } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const FooterBottomPage = ({ id }) => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: htmlData = [], isLoading: htmlIsLoading } = useGetHtmlApiQuery({
    url: id,
    lang: languageType,
  });

  const title = htmlData?.title?.[0]?.value || "Title not available";
  const body = htmlData?.body?.[0]?.value || "not available";

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(htmlData?.changed?.[0]?.value);
  }, [htmlData]);
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (htmlIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        titleLink={"/" + title.toLowerCase().split(" ").join("-")}
        levelTwo={false}
        levelThree={false}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container about_inntxt">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

          <div className="power-section">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
              {/* <div className="title-sec">
                <h4>{title}</h4>
              </div> */}
              <div dangerouslySetInnerHTML={{ __html: body }}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterBottomPage;
